import { Link, Stack } from "@mui/material";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { useCurrentUserRole } from "Hooks/useCurrentUserAccessRole";
import AdminDashboardPage from "Pages/AdminDashboardPage";
import AmlDashboardPage from "Pages/AmlDashboardPage";
import ChildDashboardPage from "Pages/ChildDashboardPage";
import CustomerDashboardPage from "Pages/CustomerDashboardPage";
import CustomerOnboardingDashboardPage from "Pages/CustomerOnboardingDashboardPage";
import DisponentDashboardPage from "Pages/DisponentDashboardPage";
import EmployeeDashboardPage from "Pages/EmployeeDashboardPage";
import HunterDashboardPage from "Pages/HunterDashboardPage";
import MerchantDashboardPage from "Pages/MerchantDashboardPage";
import {
  getResourcePath,
  Resources,
  useResource,
} from "Translations/Resources";
import { Link as RouterLink } from "Navigation/Link";
import { Trans } from "react-i18next";
import { AccessRoleCodes, type AccessRoleCode } from "Models/AccessRoleCodes";
import { appUrl } from "Utils/UrlUtils";
import type { FC } from "react";

const ROLE_TO_DASHBOARD_PAGE: Record<AccessRoleCode, FC> = {
  [AccessRoleCodes.Merchant]: MerchantDashboardPage,
  [AccessRoleCodes.Hunter]: HunterDashboardPage,
  [AccessRoleCodes.Customer]: CustomerDashboardPage,
  [AccessRoleCodes.Admin]: AdminDashboardPage,
  [AccessRoleCodes.AdminLite]: AdminDashboardPage,
  [AccessRoleCodes.Employee]: EmployeeDashboardPage,
  [AccessRoleCodes.CustomerOnboarding]: CustomerOnboardingDashboardPage,
  [AccessRoleCodes.Aml]: AmlDashboardPage,
  [AccessRoleCodes.HunterPlus]: HunterDashboardPage,
  [AccessRoleCodes.Disponent]: DisponentDashboardPage,
  [AccessRoleCodes.Child]: ChildDashboardPage,
};

export const DashboardPage = () => {
  const role = useCurrentUserRole();
  const { t } = useResource();

  if (!role) {
    return (
      <Stack gap={2} p={3} mt={3}>
        <ErrorText>{t(Resources.Dashboard.NoAccess)}</ErrorText>
        <ErrorText>
          <Trans
            i18nKey={getResourcePath(Resources.Dashboard.NoAccessRetry)}
            components={{
              signInLink: (
                <Link component={RouterLink} to={appUrl("sign-in")} />
              ),
            }}
          />
        </ErrorText>
      </Stack>
    );
  }

  const DashboardPage = ROLE_TO_DASHBOARD_PAGE[role];

  return <DashboardPage />;
};

export default DashboardPage;
